import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from './config';

export interface NewsShareItem {
  published: number | null;
  thumbnail: string | null;
  title: string | null;
  url: string | null;
}

export const brizUaAPI = createApi({
  reducerPath: 'newsPromotionsAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BRIZ_MAIN_URL || '',
  }),
  endpoints: (build) => ({
    getNews: build.query<{ items: NewsShareItem[] }, { limit: string; lang: string }>({
      query: ({ limit, lang }) => ({
        url: config.BRIZ.NEWS,
        params: {
          limit,
          lang,
        },
      }),
    }),
    getShares: build.query<{ items: NewsShareItem[] }, { limit: string; lang: string }>({
      query: ({ limit, lang }) => ({
        url: config.BRIZ.SHARES,
        params: {
          limit,
          lang,
        },
      }),
    }),
  }),
});
